export default {
  state: {
    type: null,
    name: null,
    params: null,
    query: null,
    disabled: null,
    actual: null,
    back: null
  },
  mutations: {
    set_type(state, payload) {
      state.type = payload;
    },
    set_name(state, payload) {
      state.name = payload;
    },
    set_params(state, payload) {
      state.params = payload;
    },
    set_query(state, payload) {
      state.query = payload;
    },
    set_disabled(state, payload) {
      state.disabled = payload;
    },
    set_actual(state, payload) {
      state.actual = payload;
    },
    set_back(state, payload) {
      state.back = payload;
    }
  },
  actions: {
    set_type(store, payload) {
      store.commit("set_type", payload);
    },
    set_name(store, payload) {
      let selected = store.getters.get_selected;
      store.commit("set_back", generateTo(payload - 2, store.getters.type));
      //store.commit("set_actual", generateTo(payload - 1, store.getters.type));
      store.commit("set_name", generateTo(payload, store.getters.type));
      store.commit("set_disabled", store.getters.get_actualStep > 6
          ? false
          : selected[store.getters.get_actualStep - 1] && !selected[store.getters.get_actualStep - 1].nome
      );
    },
    set_params(store, payload) {
      store.commit("set_params", payload);
    },
    set_query(store) {
      let selected = store.getters.get_selected;

      let query = {};
      if (selected[0].nome) {
        query = { ...query, convenio: selected[0].id };
      }
      if (selected[1].nome && store.getters.type === "consulta") {
        query = { ...query, especialidade: selected[1].id };
      }
      if (selected[1].nome && store.getters.type === "exame") {
        query = { ...query, procedimento: selected[1].id };
      }
      if (selected[2].nome) {
        query = { ...query, clinica: selected[2].id };
      }
      if (selected[3].nome) {
        query = { ...query, horario: selected[3].id };
      }
      if (selected[4].nome) {
        query = { ...query, medico: selected[4].id };
      }
      if (selected[5].nome) {
        query = { ...query, paciente: selected[5].id };
      }

      // console.log(store.getters.get_actualStep);
      store.dispatch("set_name", store.getters.get_actualStep + 1);
      store.commit("set_query", query);
    }
  },
  getters: {
    type(state) {
      return state.type;
    },
    name(state) {
      return state.name;
    },
    params(state) {
      return state.params;
    },
    query(state) {
      return state.query;
    },
    router_go(state) {
      return {
        name: state.name,
        query: state.query,
        params: state.params
      };
    },
    disabled(state) {
      return state.disabled;
    },
    router_back(state) {
      return {
        name: state.back,
        query: state.query,
        params: state.params
      };
    }
  }
};

function generateTo(step, type) {
  let name = `${type}_`;

  // console.log(step);
  switch (step) {
    case 1:
      name += "convenio";
      break;
    case 2:
      name += type === "exame" ? "procedimento" : "especialidade";
      break;
    case 3:
      name += "clinica";
      break;
    case 4:
      name += "agendar";
      break;
    case 5:
      name += "profissional";
      break;
    case 6:
      name += "paciente";
      break;
    case 7:
      name += "confirmacao";
      break;
    case 8:
      name = "finish";
      break;
    default:
      name = "index";
      break;
  }

  return name;
}
